// styles
require('./sendSignatureKey.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @utils
const {
    getFormattedShippingAddress,
    getFormattedShippingAddressExt
} = require('utilities/personalDataHelper');
const { changeBiocatchContext } = require("utilities/biocatch");
import { recordLinkV2 } from 'utilities/tagging';

// @ actions
const contractAddress = require('actions/contractAddress');
const sendSignatureKeyActions = require('actions/sendSignatureKey');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKLink } = require('commonsComponents/OKLink');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { LoadingSection } = require('commonsComponents/loadingSection');
const SignaturePattern = require('../../signaturePattern/signaturePattern').SignaturePattern;
const SignaturePatternButton = require("components/signaturePattern/signaturePatternButton/signaturePatternButton");

// @ constants
const { CODE_ADDRESS_EXT } = require('constants/index');
const { SEND_SIGNATURE_KEY } = require('constants/operationTypes');
const biocatch = require("constants/biocatch");
import { 
    LINK_CLICK_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_MODAL_OPEN_TAG_EVENT,
    MY_PROFILE_KEY_SIGNATURE_MODAL_VIEW_ACTION_EVENT,
    ACTION_EVENT_VIEW,
    MY_PROFILE_KEY_SIGNATURE_MODAL_CLOSE_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_MODAL_CLOSE_TAG_EVENT,
    MY_PROFILE_KEY_SIGNATURE_MODAL_SECONDARY_BUTTON_ACTION_EVENT,
    MY_PROFILE_KEY_SIGNATURE_MODAL_SECONDARY_BUTTON_TAG_EVENT,
    SEND_KEYS_SIGNATURE_EVENT_TAG,
    SEND_KEYS_SIGNATURE_CATEGORY_ERROR
} from 'constants/tagging';

class SendSignatureKey extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            isLoadingSignatureButton: false
        };
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.onSecondaryButtonClick = this.onSecondaryButtonClick.bind(this);
        this.handleConfirmClick = this.handleConfirmClick.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleSendSignatureKeyClick = this.handleSendSignatureKeyClick.bind(this);
        this.handleVolverIntentarClick = this.handleVolverIntentarClick.bind(this);
        this.navigateToSecurityKeysScreen = this.navigateToSecurityKeysScreen.bind(this);
    }

    getContractAddressData() {
        const {
            immContractAddress
        } = this.props;
        let contractAddress = '';

        if (immContractAddress.get('fetchSuccess')) {
            if (immContractAddress.get('hasContractAddress')) {
                if (immContractAddress.get('codFormatoDomicilio') === CODE_ADDRESS_EXT) {
                    contractAddress = getFormattedShippingAddressExt(immContractAddress.get('contractAddressExt').toJS());
                } else {
                    contractAddress = getFormattedShippingAddress(immContractAddress.get('contractAddress').toJS());
                }
            }
        }
        return contractAddress;
    }

    buildAddressContent(description, footerText) {
        return (
            <div className="send-signature-key-view__cmc-modal">
                <p className="send-signature-key-view__description">{description}</p>
                <p className="send-signature-key-view__contract-address">{this.getContractAddressData()}</p>
                <p className="send-signature-key-view__footer-text">{footerText}</p>
            </div>
        )
    }

    buildCmsAddressContent() {
        const { sendSignatureKey } = this.props;
        const dayLimit = sendSignatureKey.get('dayLimit');
        const description = formatText('sendSignatureKey-description');
        const footerText = (<FormattedText
            value="sendSignatureKey-footerText"
            injectedStrings={[dayLimit]}
        />);
        return this.buildAddressContent(description, footerText);
    }

    buildOtpContent() {
        return (
            <SignaturePattern
                customEventTag={SEND_KEYS_SIGNATURE_EVENT_TAG}
                customCategoryError={SEND_KEYS_SIGNATURE_CATEGORY_ERROR}
                operationType={SEND_SIGNATURE_KEY}
                isTrackingError
            />
        );
    }

    buildAlreadyRequestedKeyContent() {
        const { sendSignatureKey } = this.props;
        const lastRequestedDate = sendSignatureKey.get('lastRequestedDate');
        const dayLimit = sendSignatureKey.get('dayLimit');
        const description = (<FormattedText
            value="sendSignatureKey-alreadyRequestedKeyDescription"
            injectedStrings={[lastRequestedDate, dayLimit]}
        />)
        const footerText = formatText('sendSignatureKey-alreadyRequestedKeyFooterText');
        return this.buildAddressContent(description, footerText);
    }

    handleOpenModal() {
        const {
            fetchSignatureKeyStatus,
            getContractAddress
        } = this.props;
        fetchSignatureKeyStatus();
        getContractAddress();
        this.setState({showModal: true});
        changeBiocatchContext(biocatch.SECURITY_KEYS_PAGE);
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: LINK_CLICK_ACTION_EVENT,
            etiquetaEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_OPEN_TAG_EVENT
        });
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_VIEW_ACTION_EVENT,
            etiquetaEvento: ACTION_EVENT_VIEW
        })
    }

    buildLinkText() {
        const normalText = formatText('sendSignatureKey-sendSignatureKey_accessLinkPreTextRegenerate');
        const linkText = formatText('sendSignatureKey-sendSignatureKey_accessLinkRegenerate');

        return (
            <div>
                {normalText}
                <span className="send-signature-key-view__link">
                    <OKLink
                        modifier="emphasize"
                        onClick={this.handleOpenModal}
                        size="small"
                    >
                        {linkText}
                    </OKLink>
                </span>
            </div>
        );
    }

    handleCloseModal() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_CLOSE_ACTION_EVENT,
            etiquetaEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_CLOSE_TAG_EVENT
        })
        this.setState({
            showModal: false,
            isLoadingSignatureButton: false
        });
    }
    onSecondaryButtonClick(){
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_SECONDARY_BUTTON_ACTION_EVENT,
            etiquetaEvento: MY_PROFILE_KEY_SIGNATURE_MODAL_SECONDARY_BUTTON_TAG_EVENT
        })
        this.setState({
            showModal: false,
            isLoadingSignatureButton: false
        });

    }

    navigateToSecurityKeysScreen() {
        this.props.history.push('/myprofile/keys');
    }

    buildSuccessContent() {
        const { sendSignatureKey } = this.props;
        const dayLimit = sendSignatureKey.get('dayLimit');
        const title = formatText('sendSignatureKey-successTitle');
        const description = (<FormattedText
            value="sendSignatureKey-successDescription"
            injectedStrings={[ dayLimit ]}
        />);

        return (
            <div className="send-signature-key-view__success">
                <div className="send-signature-key-view__success--icon"/>
                <div className="send-signature-key-view__success--content">
                    <div className="send-signature-key-view__success--title">
                        {title}
                    </div>
                    <div className="send-signature-key-view__success--separator"></div>
                    <div className="send-signature-key-view__success--description">
                        {description}
                    </div>
                </div>
            </div>
        );
    }

    buildErrorContent() {
        const title = formatText('sendSignatureKey-errorTitle');
        const description = formatText('sendSignatureKey-errorDescription');

        return (
            <div className="send-signature-key-view__error">
                <div className="send-signature-key-view__error--icon"></div>
                <div className="send-signature-key-view__error--content">
                    <div className="send-signature-key-view__error--title">
                        {title}
                    </div>
                    <div className="send-signature-key-view__error--separator"></div>
                    <div className="send-signature-key-view__error--description">
                        {description}
                    </div>
                </div>
            </div>
        );
    }

    handleSendSignatureKeyClick() {
        recordLinkV2({
            categoriaEvento: window.utag_data.nombrePagina,
            accionEvento: "modal envio clave de firma",
            etiquetaEvento: "solicitar clave"
        })
        this.props.sendSignatureKeyClick();
    }

    handleVolverIntentarClick() {
        this.props.fetchSignatureKeyStatus();
    }

    handleConfirmClick() {
        this.setState({isLoadingSignatureButton: true});
        const callback = () => {
            this.setState({isLoadingSignatureButton: false});
            this.props.postSignatureKeyStatus();
        }
        this.props.validateSignatureKeyStatus(callback);
    }

    buildModalContent() {
        const { immContractAddress, sendSignatureKey } = this.props;
        const contractAddress = this.getContractAddressData();
        const isVerified = sendSignatureKey.get('isVerified');
        const content = {
            modalContent: '',
            modalTitle: formatText('sendSignatureKey-title'),
            handlePrimaryButtonClick: null,
            primaryButtonCustom: null,
            overlayClassName: 'send-signature-key-view__modal',
            primaryButtonText: '',
            secondaryButtonText: formatText('common-cancel'),
        };

        if (sendSignatureKey.get('isFetching') || sendSignatureKey.get('isOtpFetching') || immContractAddress.get('isFetching')) {
            content.modalContent = <LoadingSection />
            content.primaryButtonText = '';
            content.modalTitle = '';
            content.secondaryButtonText = '';
        } else if (sendSignatureKey.get('isFetchError')) {
            content.modalContent = this.buildErrorContent();
            content.handlePrimaryButtonClick = this.handleVolverIntentarClick;
            content.modalTitle = '';
            content.primaryButtonText = '';
        } else if (sendSignatureKey.get('isOtpError')) {
            content.modalContent = this.buildErrorContent();
            content.primaryButtonText = formatText('sendSignatureKey-volverIntentarButtonText');
            content.handlePrimaryButtonClick = this.handleVolverIntentarClick;
            content.modalTitle = '';
        } else if (sendSignatureKey.get('isSendSignatureKeyClicked')) {
            content.modalContent = this.buildOtpContent();
            content.primaryButtonCustom = (
                <SignaturePatternButton loading={this.state.isLoadingSignatureButton} onClick={this.handleConfirmClick}>
                    <FormattedText
                        value={'common-confirm'}
                    />
                </SignaturePatternButton>
            )
        } else if (sendSignatureKey.get('isOtpSuccess')) {
            content.modalContent = this.buildSuccessContent();
            content.primaryButtonText = formatText('common-exit');
            content.handlePrimaryButtonClick = this.navigateToSecurityKeysScreen;
            content.modalTitle = '';
            content.secondaryButtonText = '';
        } else if (sendSignatureKey.get('isFetchSuccess') && contractAddress) {
            if (isVerified) {
                content.modalContent = this.buildCmsAddressContent();
                content.primaryButtonText = formatText('sendSignatureKey-buttonText');
                content.handlePrimaryButtonClick = this.handleSendSignatureKeyClick;
                content.overlayClassName = "send-signature-key-view__verified";
            } else {
                content.modalContent = this.buildAlreadyRequestedKeyContent();
                content.primaryButtonText = formatText('common-cerrar');
                content.handlePrimaryButtonClick = this.handleCloseModal;
                content.modalTitle = formatText('sendSignatureKey-alreadyRequestedKeyTitle');
                content.secondaryButtonText = '';
            }
        } else if (sendSignatureKey.get('isFetchSuccess') && !contractAddress) {
            content.modalContent = this.buildErrorContent();
            content.primaryButtonText = '';
            content.modalTitle = '';
        }
        return content;
    }

    buildModal() {
        const content = this.buildModalContent();

        return (
            <OKModal
                content={content.modalContent}
                contentOverflow="auto"
                footerType="navigation"
                isOpen={this.state.showModal}
                onCloseCallback={this.handleCloseModal}
                onPrimaryButtonClick={content.handlePrimaryButtonClick}
                onSecondaryButtonClick={this.onSecondaryButtonClick}
                overlayClassName={content.overlayClassName}
                primaryButtonCustom={content.primaryButtonCustom}
                primaryButtonText={content.primaryButtonText}
                secondaryButtonText={content.secondaryButtonText}
                shouldCloseOnOverlayClick={false}
                title={content.modalTitle}
            />
        )
    }

    render() {
        return (
            <div className="send-signature-key-view">
                {this.buildLinkText()}
                {this.buildModal()}
            </div>
        )
    }
}

SendSignatureKey.propTypes = {
    fetchSignatureKeyStatus: PropTypes.func,
    getContractAddress: PropTypes.func,
    history: PropTypes.object.isRequired,
    immContractAddress: PropTypes.object.isRequired,
    postSignatureKeyStatus: PropTypes.func,
    sendSignatureKey: PropTypes.object.isRequired,
    sendSignatureKeyClick: PropTypes.func,
    showModal: PropTypes.bool.isRequired,
    validateSignatureKeyStatus: PropTypes.func,
};

module.exports.constructor = SendSignatureKey;
module.exports.SendSignatureKey = connect(
    state => ({
        immContractAddress: state.contractAddress,
        sendSignatureKey: state.sendSignatureKey
    }), {
        fetchSignatureKeyStatus: sendSignatureKeyActions.fetchSignatureKeyStatus,
        getContractAddress: contractAddress.getContractAddress,
        postSignatureKeyStatus: sendSignatureKeyActions.postSignatureKeyStatus,
        sendSignatureKeyClick: sendSignatureKeyActions.sendSignatureKeyClick,
        validateSignatureKeyStatus: sendSignatureKeyActions.validateSignatureKeyStatus,
    }
)(withRouter(SendSignatureKey));
